import { Api } from './api';

export class TasksApi {
    private static readonly PATH = '/tasks';

    constructor(private readonly m_api: Api) {}

    public async getTasks() {
    return this.m_api.get(`${TasksApi.PATH}/user-tasks`);
    }

    public async checkJoinChannel(taskId: number) {
        return this.m_api.get(`${TasksApi.PATH}/check-join-channel?taskId=${taskId}`);
    }

    public async viewJoinChannel(taskId: number) {
        return this.m_api.post(`${TasksApi.PATH}/view-join-channel`, { taskId });
    }

    public async performVkShareTask(taskId: number) {
        return this.m_api.post(`${TasksApi.PATH}/perform-vk-share`, { taskId });
    }

    public async checkVkShareTask(taskId: number) {
        return this.m_api.post(`${TasksApi.PATH}/check-vk-share`, { taskId });
    }

    public async setHomescreenShortcutTask() {
        return this.m_api.post(`${TasksApi.PATH}/set-homescreen-shortcut`, {});
    }
}